@if (items().length) {
  <div
    class="ssrk-announcement-ticker flex w-full max-w-full items-stretch overflow-hidden bg-ssrk-danger"
    role="region"
    [attr.aria-label]="ariaLabel()"
  >
    <span
      class="ssrk-announcement-ticker__label flex shrink-0 items-center bg-ssrk-saffron px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white sm:px-3 sm:text-xs"
    >
      {{ label() }}
    </span>

    <div class="ssrk-announcement-ticker__viewport min-w-0 flex-1 overflow-hidden">
      <div class="ssrk-announcement-ticker__track flex w-max items-center gap-6 py-1.5 pl-3 pr-6 text-[12px] font-medium text-white sm:gap-8 sm:text-[13px]">
        @for (item of loopItems(); track $index) {
          <span class="ssrk-announcement-ticker__item inline-flex shrink-0 items-center gap-6 sm:gap-8">
            @if (item.href) {
              <a
                [href]="item.href"
                class="whitespace-nowrap text-white underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                {{ item.text }}
              </a>
            } @else {
              <span class="whitespace-nowrap">{{ item.text }}</span>
            }
            <span class="text-white/70" aria-hidden="true">•</span>
          </span>
        }
      </div>
    </div>
  </div>
}
